/* eslint-disable react/jsx-max-depth */

/**
 * Libs
 */
import React from 'react';
import { Spacing } from 'src/ui/common/atoms/spacing';

/**
 * Components
 */
import { Typography } from 'src/ui/common/atoms/typography';
import { TechPageContent } from './components/tech-page-content';
import { TechPageHeader } from './components/tech-page-header';
import { TechPageSection } from './components/tech-page-section';


export const TechPrivacyContainer = () => (
    <>
        <TechPageHeader title="Privacy Policy and Cookie Policy" subtitle="Latest update:  15 September, 2023" />
        <TechPageContent>
            <TechPageSection>
                <Typography color="text" tag="p">
                    Welcome to Tech Contemporary A/S ("we," "our," or "us"). We are committed to protecting your privacy
                    and ensuring the security of your personal information. This Privacy Policy and Cookie Policy
                    explains how we collect, use, disclose, and protect your personal information when you use our
                    website, products, and services.
                </Typography>
                <Spacing padding="0 30px">
                    <Typography color="text" tag="p" semiBold>
                        1. Information We Collect
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        1.1 Personal Information
                    </Typography>
                    <Typography color="text" tag="p">
                        We may collect the following personal information when you interact with our website or
                        services:
                    </Typography>
                    <ul>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Contact Information:
                            </Typography>
                            such as your name, email address, phone number, and shipping address.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Payment Information:
                            </Typography>
                            such as credit card details, billing information, and other payment-related information.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Account Information:
                            </Typography>
                            f you create an account with us, we may collect your username, password, and other account
                            details.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Communications:
                            </Typography>
                            any communications you have with us, including emails, messages, or customer support
                            inquiries.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Demographic Information:
                            </Typography>
                            such as your age, gender, and location.
                        </li>
                    </ul>
                    <Typography color="text" tag="span" semiBold size="xs">
                        1.2 Usage and Technical Information
                    </Typography>
                    <Typography color="text" tag="p">
                        We automatically collect certain information about your use of our website and services,
                        including:
                    </Typography>
                    <ul>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Log Data:
                            </Typography>
                            such as your IP address, browser type, operating system, and the pages you visit.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Cookies and Tracking Technologies:
                            </Typography>
                            as described in our Cookie Policy (Section 2).
                        </li>
                    </ul>
                    <Typography color="text" tag="p" semiBold>
                        2. Use of Cookies
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.1 What Are Cookies?
                    </Typography>
                    <Typography color="text" tag="p">
                        Cookies are small pieces of data stored on your device (computer, smartphone, tablet) when you
                        visit our website. They help us improve your browsing experience and provide personalized
                        services. Cookies may also be used by third-party services that we use for analytics,
                        advertising, and other purposes.
                    </Typography>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.2 Types of Cookies We Use
                    </Typography>
                    <ul>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Essential Cookies:
                            </Typography>
                            These cookies are necessary for the website to function correctly. They are typically set in
                            response to actions you take, such as logging in or making a purchase.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Analytical and Performance Cookies:
                            </Typography>
                            These cookies help us understand how you use our website, which pages are visited most
                            often, and if you encounter any errors. We use this information to improve our website's
                            performance and user experience.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Advertising Cookies:
                            </Typography>
                            These cookies may be set by our advertising partners to deliver targeted advertisements
                            based on your interests. They may also track your interactions with these advertisements.
                        </li>
                        <li>
                            <Typography color="text" tag="span" semiBold size="xs">
                                Functionality Cookies:
                            </Typography>
                            These cookies enhance the functionality of our website by remembering your preferences, such
                            as language or region settings.
                        </li>
                    </ul>
                    <Typography color="text" tag="span" semiBold size="xs">
                        2.3 Managing Cookies
                    </Typography>
                    <Typography color="text" tag="p">
                        You can manage and control cookies in your browser settings. You can choose to block or delete
                        cookies, but please note that doing so may affect your experience on our website.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        3. How We Use Your Information
                    </Typography>
                    <Typography color="text" tag="p">
                        We use your personal information for the following purposes:
                    </Typography>
                    <ul>
                        <li>To provide you with our products and services.</li>
                        <li>To process and fulfill your orders and requests.</li>
                        <li>To communicate with you regarding your orders, inquiries, and promotions.</li>
                        <li>To improve our website and services.</li>
                        <li>To protect our rights, interests, and the security of our website.</li>
                        <li>To comply with legal obligations.</li>
                    </ul>
                    <Typography color="text" tag="p" semiBold>
                        4. Sharing Your Information
                    </Typography>
                    <Typography color="text" tag="p">
                        We may share your personal information with:
                    </Typography>
                    <ul>
                        <li>
                            Service Providers: Third-party service providers who assist us in operating our website,
                            processing payments, and delivering products to you.
                        </li>
                        <li>Legal Authorities: If required by law or to protect our rights or safety.</li>
                        <li>
                            Business Partners: With your consent, we may share your information with business partners
                            for marketing and promotional purposes.
                        </li>
                    </ul>
                    <Typography color="text" tag="p" semiBold>
                        5. Your Choices and Rights
                    </Typography>
                    <Typography color="text" tag="p">
                        You have certain rights regarding your personal information, including:
                    </Typography>
                    <ul>
                        <li>
                            Access and Correction: You can access and correct your personal information through your
                            account settings or by contacting us.
                        </li>
                        <li>
                            Deletion: You can request the deletion of your personal information, subject to legal
                            requirements.
                        </li>
                        <li>
                            Opt-Out: You can opt-out of receiving promotional emails by following the unsubscribe
                            instructions in the email.
                        </li>
                        <li>Do Not Track: Our website does not respond to "Do Not Track" signals.</li>
                    </ul>
                    <Typography color="text" tag="p" semiBold>
                        6. Security
                    </Typography>
                    <Typography color="text" tag="p">
                        We take reasonable steps to protect your personal information from unauthorized access, use, or
                        disclosure. However, no data transmission over the internet or storage system is completely
                        secure. Please take appropriate precautions to protect your personal information.
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        7. Changes to this Privacy and Cookie Policy
                    </Typography>
                    <Typography color="text" tag="p">
                        We may update this Privacy Policy and Cookie Policy from time to time. Any changes will be
                        posted on this page, and the "Last Updated" date will be revised accordingly
                    </Typography>
                    <Typography color="text" tag="p" semiBold>
                        8. Contact Us
                    </Typography>
                    <Typography color="text" tag="p">
                        If you have any questions or concerns about our privacy practices or this policy, please contact
                        us at <a href="mailto:emil@techcontemporary.com">emil@techcontemporary.com.</a>
                    </Typography>
                    <Typography color="text" tag="p">
                        By using Tech Contemporary, you acknowledge that you have read, understood, and agreed to our
                        Privacy & Cookie Policy. Thank you for choosing Tech Contemporary as your platform for digital
                        art exploration and creation.
                    </Typography>
                </Spacing>
            </TechPageSection>
        </TechPageContent>
    </>
);